// Core
import { call, put, select } from 'redux-saga/effects';
import { Map } from 'immutable';
import moment from 'moment';

// Instruments
import { historyActions } from 'bus/history/actions';
import { historyStorage as storage } from 'bus/history/storage';
import { hotelsActions } from 'bus/hotels/actions';
import { offersActions } from 'bus/offers/actions';

export function* loadViewedHotelsWorker () {
    try {
        const hotelGroupedByStatus = Map(yield call([storage, 'findAll'])).groupBy(({ expires }) => moment().isSameOrBefore(expires) ? 'actual' : 'outdated');
        const outdated = hotelGroupedByStatus.get('outdated', Map());
        const actual = hotelGroupedByStatus.get('actual', Map());

        for (const hotelId of outdated.keySeq().toArray()) {
            yield put(historyActions.removeViewedHotel(hotelId));
        }

        const hotels = actual.map(({ hotel }) => hotel);
        const offers = actual.map(({ offer }) => offer).mapKeys((hotelId, { id }) => id);
        const viewedHotels = actual.map(({ hotel: { id: hotelId }, offer: { id: offerId }}) => ({ hotelId, offerId }));

        if (hotels.count() && offers.count()) {
            yield put(hotelsActions.addHotels(hotels));
            yield put(offersActions.addOffers(offers));
        }

        yield put(historyActions.loadViewedHotelsSuccess(viewedHotels));
    } catch (error) {
        yield put(historyActions.loadViewedHotelsFail(error));
    }
}
